import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { _className, Button, LL_H_C, LL_V_L, openContent, TS_ButtonLoader } from '@nu-art/thunderstorm-frontend/index';
import { MUSTNeverHappenException, StaticLogger } from '@nu-art/ts-common';
import './Header_ResolutionFunctionEditor.scss';
import { ICONS } from '@app/styles';
import { IconWithTooltip } from '@app/styles';
import { ModuleFE_PathwayTransition } from '../../../_entity.js';
export class Header_ResolutionFunction extends React.Component {
    constructor(props) {
        super(props);
        this.state = { uperting: false };
    }
    renderLoader = () => {
        if (!this.state.uperting)
            return '';
        return _jsx(TS_ButtonLoader, {});
    };
    renderMenuIcon = () => {
        if (!this.props.actions)
            return;
        const expandCollapseClassName = _className('quai-manager-ui__header__actions-icon', 'expand-button', this.props.expandStatus && 'expanded');
        return _jsxs(LL_H_C, { style: { gap: '10px' }, children: [_jsx(ICONS.advisorCollapseAll.component, { className: expandCollapseClassName, onClick: this.props.expandCollapseAll }), _jsx(Button, { variant: 'primary', onClick: async () => {
                        await Promise.all(this.props.editables.map(async (editable) => {
                            if (editable.hasChanges())
                                await editable.save();
                        }));
                        await this.props.deselectResolutionFunction();
                    }, className: 'preferred-action', children: "Save" }), _jsx(ICONS.more.component, { className: 'quai-manager-ui__header__actions-icon', ...openContent.popUp.bottom('quai-manager-ui__header__actions', this.renderMenu, 10) })] });
    };
    resolveTransitionNames = () => {
        return this.props.availableTransitionsIds.map(transitionId => {
            const transition = ModuleFE_PathwayTransition.cache.unique(transitionId);
            if (!transition)
                throw new MUSTNeverHappenException(`transition with ${transitionId} not found`);
            return transition.label;
        }).join(', ');
    };
    renderMenu = (refreshPopup) => {
        return _jsx(_Fragment, { children: this.props.actions.map((action, index) => {
                const className = _className('quai-manager-ui__header__actions__action');
                return _jsx("div", { className: className, onClick: () => {
                        action.action();
                    }, children: action.label }, action.label);
            }) });
    };
    renderHeaderMain = () => {
        return _jsxs(LL_V_L, { className: 'quai-manager-ui__header__main', children: [_jsxs(LL_H_C, { style: { gap: '5px' }, className: 'quai-manager-ui__header__title', children: [_jsx("span", { onClick: async () => {
                                this.setState({ uperting: true }, async () => {
                                    try {
                                        await this.props.deselectResolutionFunction();
                                    }
                                    catch (err) {
                                        StaticLogger.logError(err);
                                        this.setState({ uperting: false });
                                    }
                                });
                            }, className: 'clickable', children: this.props.state.name }), "Resolution Function", this.props.availableTransitionsIds.length ? _jsx(IconWithTooltip, { content: `The following transitions missing resolution function:\n${this.resolveTransitionNames()}`, iconKey: 'attention' }) : null, this.renderLoader()] }), _jsx("div", { className: 'quai-manager-ui__header__subtitle', children: "State" })] });
    };
    render() {
        return _jsxs(LL_H_C, { id: 'resolution-function-header', className: 'quai-manager-ui__header small-title', children: [this.renderHeaderMain(), this.renderMenuIcon()] });
    }
}
//# sourceMappingURL=Header_ResolutionFunctionEditor.js.map